import { OccConfig } from '@spartacus/core';

export const userAuxOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        validateAccount: '/register/validateAccount/${accountNumber}',
        validateEmail: '/register/verify-email',
        businessTypes: '/register/businessTypes',
        productCategories: '/register/productCategories',
        requestRole: '/users/${userId}/requestRole/${role}',
        requestAccount: '/users/${userId}/requestAccount/${accountNumber}',
        stateRegions: '/countries/${isoCode}/regions?fields=regions(name,isocode,isocodeShort)',
        register: '/register/',
      } as any,
    },
  },
};
